<script>
export default {
    name: "COAIndex",

    data() {

        return {
            coas: [],
            categories: [],
            addCOA: false,
            chartOfA: {
                coaid: 0,
                categoryID: 0,
                category: ``,
                coaName: ``,
                description: ``,
                date: this.$moment().format(`YYYY-MM-DD`),
                openingBal: 0,
                userName: this.$root.username,
                active: true,
            },
        };
    },

    mounted() {
        this.$root.loading = true;
        Promise.all([ this.fetchCOAs(), this.fetchCategories(), ]).then(() => {
            this.$root.loading = false;
        }).catch(() => { this.$root.loading = false; });
    },

    methods: {

        fetchCOAs() {
            let url = `Accounting/GetCOA`;
            return this.$http.get(url).then(({ data }) => {
                this.coas = data;
            }).catch(() => {});
        },

        fetchCategories() {
            let url =`Accounting/GetCOACategories`;
            return this.$http.get(url).then(({ data }) => {
                this.categories = data;
            }).catch(() => {});
        },
    },

    components: {
        "coa-form": () => import('./modals/Form.vue'),
    },
}
</script>
<template>
    <tail-base-layout>
  <template v-slot:breadcrum>
      <div class="bg-blue-800 p-tiny text-xs text-white rounded">
         <nav class="bg-grey-light rounded font-sans w-full p-tiny">
           <ol class="list-reset flex text-grey-dark">
             <li>
                <router-link :to="{name : `master-data.accounts.index` }">Accounts master data</router-link>
             </li>
             <li><span class="mx-2">/</span></li>
             <li>Chart Of Accounts</li>
           </ol>
         </nav>
      </div>
  </template>
  <template v-slot:content>
      <tail-card>
        <template v-slot:card-header>
          <h5 class="text-sm">Chart Of Accounts</h5>
        </template>
        <template v-slot:card-body>
            <div class="w-full flex flex-wrap">
        <div class="w-full flex flex-wrap mb-2">
            <div class="flex-1"></div>
            <div class="w-1/12 text-right">
                <button 
                    @click.prevent="addCOA=true"
                    class="btn-sm btn-primary text-xs rounded">Add Account</button>
            </div>
            <coa-form 
                :coa="chartOfA"
                :categories="categories"
                :showModal="addCOA" 
                @closeModal="addCOA = false"
                @refresh="() => {
                    chartOfA={
                        coaid: 0,
                        categoryID: 0,
                        category: ``,
                        coaName: ``,
                        description: ``,
                        date: $moment().format(`YYYY-MM-DD`),
                        openingBal: 0,
                        userName: $root.username,
                        active: true,
                    };
                    fetchCOAs();
                }" 
            />
        </div>
        <div class="w-full overflow-auto" style="max-height:35rem;">
            <table class="table text-xs">
                <thead class="bg-blue-500 text-white">
                    <tr>
                        <th class="p-tiny">Id</th>
                        <th class="p-tiny">Category</th>
                        <th class="p-tiny">COA</th>
                        <th class="p-tiny">Opening Bal.</th>
                        <th class="p-tiny">As Of</th>
                        <th class="p-tiny">Active</th>
                        <th class="p-tiny">Action</th>
                    </tr>
                </thead>
                <tbody class="bg-gray-100">
                    <tr v-for="coa in coas" :key="coa.coaid">
                        <td class="p-tiny">{{ coa.coaid }}</td>
                        <td class="p-tiny">{{ coa.coaCategory }}</td>
                        <td class="p-tiny">{{ coa.name }}</td>
                        <td class="p-tiny">{{ coa.opening_Balance | numberFormat }}</td>
                        <td class="p-tiny">{{ coa.as_Of | dateFormat }}</td>
                        <td class="p-tiny">{{ coa.active ? `Y` : `N` }}</td>
                        <td class="p-tiny">
                            <button 
                                @click.prevent="() => {
                                    chartOfA={
                                        coaid: coa.coaid,
                                        categoryID: coa.coaCategoryID,
                                        category: coa.coaCategory,
                                        coaName: coa.name,
                                        description: ``,
                                        date: $moment(coa.as_Of).format(`YYYY-MM-DD`),
                                        openingBal: coa.opening_Balance,
                                        userName: $root.username,
                                        active: coa.active,
                                    };
                                    addCOA=true;
                                }"
                                class="btn-sm btn-info text-xs rounded">
                                <i class="fa fa-edit"></i></button>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
        </template>
      </tail-card>
  </template>
</tail-base-layout>
</template>